import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g>
      <path
        className="path1"
        d="M8.25667 10.0134C8.31411 9.09595 8.34431 8.14533 8.34431 7.17129C8.34431 6.77667 8.33936 6.38589 8.32964 5.9996C8.32276 5.72622 8.2341 5.46054 8.07226 5.24011C7.45995 4.40615 6.97164 3.88708 6.16796 3.2666C5.94546 3.09481 5.67237 3.00164 5.39135 2.99551C5.11179 2.98942 4.81987 2.98633 4.50809 2.98633C3.56416 2.98633 2.80223 3.01468 2.0144 3.06872C1.33859 3.11507 0.801851 3.6531 0.759518 4.32917C0.702069 5.24663 0.671875 6.19725 0.671875 7.17129C0.671875 8.14533 0.702069 9.09595 0.759518 10.0134C0.801852 10.6895 1.33859 11.2275 2.0144 11.2739C2.80223 11.3279 3.56416 11.3562 4.50809 11.3562C5.45203 11.3562 6.21395 11.3279 7.00178 11.2739C7.67759 11.2275 8.21433 10.6895 8.25667 10.0134Z"
        fill="white"
        stroke={props.stroke || '#070F21'}
      />
      <path
        className="path1"
        d="M11.2404 7.66967C11.2979 6.75221 11.3281 5.80158 11.3281 4.82754C11.3281 4.43292 11.3231 4.04214 11.3134 3.65586C11.3066 3.38247 11.2179 3.11679 11.056 2.89636C10.4437 2.0624 9.95537 1.54333 9.15171 0.922847C8.92919 0.751064 8.65611 0.657885 8.37511 0.651762C8.09555 0.645672 7.80364 0.642578 7.49186 0.642578C6.54792 0.642578 5.786 0.670934 4.99817 0.724973C4.32236 0.771327 3.78562 1.30935 3.74328 1.98542C3.68583 2.90288 3.65564 3.8535 3.65564 4.82754C3.65564 5.80158 3.68584 6.75221 3.74328 7.66967C3.78562 8.34573 4.32236 8.88375 4.99817 8.93012C5.786 8.98412 6.54792 9.01249 7.49186 9.01249C8.43579 9.01249 9.19774 8.98412 9.98554 8.93012C10.6614 8.88375 11.1981 8.34574 11.2404 7.66967Z"
        fill="white"
        stroke={props.stroke || '#070F21'}
      />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const CopyIcon = memo(ForwardRef);
export default CopyIcon;
